import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataOutputModel, Opdata } from 'src/app/models/opdata.model';
import { OpdataCalc } from 'src/app/models/opdataCalc.model';
import { Plant } from 'src/app/models/plant.model';
import { Stage } from 'src/app/models/role.model';
import { Train } from 'src/app/models/train.model';
import { Unit } from 'src/app/models/unit.interface';
import { OpdataService } from 'src/app/services/opdata/opdata.service';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { TrainService } from 'src/app/services/trains/trains.service';
import { Location } from '@angular/common';
import {
  PagingHeader,
  QueryStringParameters,
} from 'src/app/shared/shared.model';

import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-rawopdata-list',
  templateUrl: './rawopdata-list.component.html',
  styleUrls: ['./rawopdata-list.component.scss'],
})
export class RawopdataListComponent {
  public units: Array<Unit> = [
    { Id: 0, UnitName: 'Metric' },
    { Id: 1, UnitName: 'English' },
  ];

  public stages: Array<Stage> = [
    { Id: 1, Name: '1' },
    { Id: 2, Name: '2' },
    { Id: 3, Name: '3' },
    { Id: 4, Name: 'Total' },
  ];

  showstageone() {
    this.stages1 = false;
    this.stages2 = true;
    this.stages3 = true;
    this.total = true;
  }

  showstagetwo() {
    this.stages1 = true;
    this.stages2 = false;
    this.stages3 = true;
    this.total = true;
  }

  showstagethree() {
    this.stages1 = true;
    this.stages2 = true;
    this.stages3 = false;
    this.total = true;
  }

  showstagetotal() {
    this.stages1 = true;
    this.stages2 = true;
    this.stages3 = true;
    this.total = false;
  }

  OpdataIds: number[] = [];

  queryParam: QueryStringParameters = new QueryStringParameters();
  pageHeaders: PagingHeader = new PagingHeader();
  config: any;
  sortDir = 1; //1= 'ASE' -1= DSC

  trainDetails: Train = new Train();
  showDvUnit = false;
  showDownload = false;
  trains: Train[] = [];
  trainnew: Train[] = [];
  plants: Plant[] = [];
  opdata: Opdata[] = [];
  calcOpdata: OpdataCalc[] = [];
  allTrainList: Train[] = [];
  trainById: Train[] = [];
  opdataList: Opdata[] = [];
  calcOpdataList: OpdataCalc[] = [];
  calcOpdataTotal : OpdataCalc[]=[];
  showTable = false;
  showTableCalc = false;
  stages1 = false;
  stages2 = true;
  stages3 = true;
  total = true;
  SelectedId: string;
  showdivplant = false;
  newId: string;
  ShowTrainName = false;
  isfromOPdata: boolean;
  PlantId: string;
  trainId: string;
  ConvertedtrainId: number;
  convertedPlantId: number;
  opdataWithFlagD: Opdata[] = [];
  opdataWithFlagI: Opdata[] = [];
  selectedPlantId: string;

  loggedInUserRole:string;
  loggedinUserId:string;
  plantAndUserId:string;
  
  type: string =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

  // constructor(
  //   private route: ActivatedRoute,
  //   private router: Router,
  //   private trainService: TrainService,
  //   private plantService: PlantsService,
  //   private opdataService: OpdataService,
  //   private location: Location,
  //   private toastr: ToastrService
  // ) {
  //   this.route.queryParams.subscribe((params) => {
  //     this.PlantId = atob(params['PlantId']!);
  //     this.trainId = atob(params['trainId']!);
  //     this.SelectedId = params['trainId'];
  //     this.newId = this.SelectedId;
  //   });
  // }

  constructor(
  private route: ActivatedRoute,
  private router: Router,
  private trainService: TrainService,
  private plantService: PlantsService,
  private opdataService: OpdataService,
  private location: Location,
  private toastr: ToastrService
) {
  const navigation = this.router.getCurrentNavigation();
  const state = navigation?.extras?.state || history.state;

  if (state) {
    this.PlantId = state.PlantId;
    this.trainId = state.trainId;
    this.SelectedId = state.trainId;
    this.newId = this.SelectedId;

    this.queryParam.PageSize = state.PageSize ?? 10;
    this.queryParam.PageNumber = state.PageNumber ?? 1;
    this.queryParam.MaxPageSize = state.MaxPageSize ?? 10;
    this.queryParam.SearchQuery = state.SearchQuery ?? '';
    this.queryParam.OrderBy = state.OrderBy ?? '';
    this.queryParam.OrderDir = state.OrderDir ?? '';
    this.queryParam.SelectedValue = state.SelectedValue ?? '';

    console.log('Constructor - State data received:', state);
  }
}

  
  rawdataloader() {
    this.showdivplant = false;

    this.plantService.getAllPlant().subscribe({
      next: (plants) => {
        this.plants = plants;
      },
      error: (response) => {
        console.log(response);
      },
    });

    this.convertedPlantId = +this.PlantId;
    this.ConvertedtrainId = +this.trainId;

    if(this.loggedInUserRole =='Standard User')
      {
          this.plantAndUserId = this.SelectedId + 'Z' + this.loggedinUserId;
          this.trainService.GetAccessibleTrainListByPlantId(this.plantAndUserId ).subscribe(
          
            (response: Train[]) => {
              this.allTrainList = response;
              console.log(this.allTrainList);
              
            },
      
            (error: any) => {
              console.log('error list');
            }
          );
      }
      else
      {
    this.trainService.getTrainByPlantId(this.PlantId).subscribe(
      (response: Train[]) => {
        this.allTrainList = response;
        console.log(this.allTrainList);
      },
      (error: any) => {
        console.log('error list');
      }
    );
  }
    this.trainService.getTrainById(this.trainId).subscribe({
      next: (response) => {
        this.trainDetails = response;
      },
    });

    this.opdataService
      .getRawOpdataByTrainId(this.queryParam, this.trainId)
      .subscribe((response: DataOutputModel) => {
        this.opdataList = response.Items;
        this.pageHeaders = response.Paging;
        this.showDvUnit = true;
        this.showDownload = true;
      });
      this.opdataService
      .getCalcOpdataByTrainId(this.trainId)
      .subscribe((response) => {
        this.calcOpdataTotal = response;
       
      });
    this.getGetOPdatawithIflagById(this.trainId);
    this.getGetOPdatawithDflagById(this.trainId);
  }

  // selectednoOtherUser(calcId) {
  //   if (this.OpdataIds.includes(calcId)) {
  //     let Index = this.OpdataIds.indexOf(calcId);
  //     this.OpdataIds.splice(Index, 1);
  //   } else {
  //     this.OpdataIds.push(calcId);
  //   }
    
  // }
  
   masterSelected: boolean = false;

  selectednoOtherUser(calcId) {
    if (this.OpdataIds.includes(calcId)) {
      let Index = this.OpdataIds.indexOf(calcId);
      this.OpdataIds.splice(Index, 1);
    } else {
      this.OpdataIds.push(calcId);
    }
     console.log(this.OpdataIds);

      // Update master checkbox if all rows are selected
  this.masterSelected = this.OpdataIds.length === this.opdataList.length;
  console.log(this.OpdataIds);
  }

  
selectAllRows() {
  if (this.masterSelected) {
    this.OpdataIds = this.opdataList.map(x => x.Id);
  } else {
    this.OpdataIds = [];
  }
  console.log(this.OpdataIds);
}

isRowSelected(calcId: number): boolean {
  return this.OpdataIds.includes(calcId);
}


  navigate(TId){
    console.log(TId);
    var id = btoa(TId.toString())
    this.router.navigate(['/opdata/edit/' + id]);
  }

  softdelete() {
    console.log(this.OpdataIds);
    const confirmDelete = confirm(
      'Are you sure you want to delete selected opdata?'
    );
    if (!confirmDelete) {
      return; 
    }
    
    this.opdataService
      .softDeleteModelForOpdata(this.trainId, this.OpdataIds)
      .subscribe({
        next: (List) => {
          this.toastr.error('Opdata deleted successfully!', 'Information');
          this.OpdataIds = []
          this.opdataService
            .getRawOpdataByTrainId(this.queryParam, this.trainId)
            .subscribe((response: DataOutputModel) => {
              this.opdataList = response.Items;
              this.pageHeaders = response.Paging;
              this.showDvUnit = true;
              this.showDownload = true;
            });
          this.getGetOPdatawithIflagById(this.trainId);
          this.getGetOPdatawithDflagById(this.trainId);
        },
      });
  }

  Undo() {
    console.log(this.OpdataIds);
    this.opdataService
      .opdataUndo(this.trainId)
      .subscribe((response: Response) => {
        if (response.statusText == 'Success') {
          this.toastr.success('opdata Undo successfully.', 'Information');
          this.OpdataIds = []
          this.opdataService
            .getRawOpdataByTrainId(this.queryParam, this.trainId)
            .subscribe((response: DataOutputModel) => {
              this.opdataList = response.Items;
              this.pageHeaders = response.Paging;
              this.showDvUnit = true;
              this.showDownload = true;
            });
          this.getGetOPdatawithIflagById(this.trainId);
          this.getGetOPdatawithDflagById(this.trainId);
        } else {
          (error) => {
            console.log('Error processing Undo of opdata:', error);
            this.OpdataIds = []
          };
        }
      });
  }

  ngOnInit(): void {
    this.ShowTrainName = false;
    // this.queryParam.PageSize = 10;
    // this.queryParam.PageNumber = 1;
    // this.queryParam.MaxPageSize = 10;
    
     // Read query parameters from URL
    this.route.queryParams.subscribe((params) => {

      if (params['PageSize']) {
        this.queryParam.PageSize = +params['PageSize'];
      }
      if (params['PageNumber']) {
        this.queryParam.PageNumber = +params['PageNumber'];
      }
      if (params['MaxPageSize']) {
        this.queryParam.MaxPageSize = +params['MaxPageSize'];
      }
      if (params['SearchQuery']) {
        this.queryParam.SearchQuery = params['SearchQuery'];
      }
      if (params['OrderBy']) {
        this.queryParam.OrderBy = params['OrderBy'];
      }
      if (params['OrderDir']) {
        this.queryParam.OrderDir = params['OrderDir'];
      }
      if (params['SelectedValue']) {
        this.queryParam.SelectedValue = params['SelectedValue'];
      }
      
      // Also read existing parameters
      if (params['PlantId']) {
        this.PlantId = atob(params['PlantId']);
      }
      if (params['trainId']) {
        this.trainId = atob(params['trainId']);
        this.SelectedId = params['trainId'];
        this.newId = this.SelectedId;
      }
    });

    
    this.config = {
      currentPage: 1,
      itemsPerPage: this.queryParam.PageSize,
    };

    this.showdivplant = false;

    if (this.PlantId != null) {
      this.rawdataloader();
    } else {
      this.route.paramMap.subscribe({
        next: (params) => {
          const enId = params.get('id');
          const id = atob(params.get('id')!);
          if (enId != null) {
            this.newId = id;
            this.ShowTrainName = true;
            this.getGetOPdatawithIflagById(id);
            this.getGetOPdatawithIflagById(id);
            this.opdataService
              .getRawOpdataByTrainId(this.queryParam, id)
              .subscribe((response: DataOutputModel) => {
                this.opdataList = response.Items;
                this.pageHeaders = response.Paging;
                console.log(this.opdataList);
              });

            this.trainService.getTrainById(id).subscribe({
              next: (response) => {
                this.trainDetails = response;
              },
            });

            this.showDvUnit = true;
            this.showDownload = true;
            this.showdivplant = true;
          } else {
            //this.getSelectedId(this.newId);
             this.getSelectedId({
    target: {
      value: this.newId
    }
  });
          }
        },
      });
    }

    this.showTableCalc = true;
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if(loggedInuserRole.role =='Standard User')
    {
      this.loggedInUserRole = loggedInuserRole.role;
    this.loggedinUserId = loggedInuserRole.userId;
      this.plantService.getPlantsByUserId(loggedInuserRole.userId)
      .subscribe({
        next: (plants)=>{
          this.plants = plants;
        },
      })
      
    }
    else
    {
    this.plantService.getAllPlant().subscribe({
      next: (plants) => {
        this.plants = plants;
      },
      error: (response) => {
        console.log(response);
      },
    });
  }

         //load data using plantId from breadcrumbs
    this.plantService.selectedPlant$.subscribe(plantId => {
      if (plantId) {
          this.gettrainsbyplantId({ target: { value: plantId } });
      }
    });

           //load data using trainId from breadcrumbs
    this.plantService.selectedTrain$.subscribe(trainId => {
      if (trainId) {
          this.getSelectedId({ target: { value: trainId } });
      }
    });
    
    // this.plantService.selectedTrain$
    //   .subscribe(trainId => {
    //     if (trainId) {
    //       this.getSelectedId({ target: { value: trainId } });
    //     }
    //   });
  
  }

  //added for remove infinity pagenation error from console
  safePageSize(size: any): number {
    return size && size > 0 ? size : 10;
  }

  safePageNumber(page: any): number {
    return page && page > 0 ? page : 1;
  }

  safeTotalItems(total: any): number {
    return total || 0;
  }
  
  gettrainsbyplantId(e) {
    this.SelectedId = e.target.value;
    console.log(e);
    this.selectedPlantId = this.SelectedId;
    this.PlantId = this.SelectedId;
    this.trainService.getTrainByPlantId(this.SelectedId).subscribe(
      (response: Train[]) => {
        this.allTrainList = response;
        console.log(this.allTrainList);
        this.showDvUnit = true;
        this.showDownload = true;
      },
      (error: any) => {
        console.log('error list');
      }
    );
  }


  getSelectedId(e) {
    
    this.SelectedId = e.target.value;    
    this.newId = this.SelectedId;
    this.showDvUnit = true;
    this.showDownload = true;
    
    this.trainId = this.SelectedId;

    this.opdataService
      .getRawOpdataByTrainId(this.queryParam, this.SelectedId)
      .subscribe((response: DataOutputModel) => {
        this.opdataList = response.Items;
        this.pageHeaders = response.Paging;
        console.log(this.opdataList);
      });

    this.trainService.getTrainById(this.SelectedId).subscribe({
      next: (response) => {
        this.trainDetails = response;
      },
    });

    this.getGetOPdatawithIflagById(this.SelectedId);
    this.getGetOPdatawithDflagById(this.SelectedId);
  }

  getGetOPdatawithDflagById(TrainId) {
    this.opdataService.GetOPdatawithDflagById(TrainId).subscribe({
      next: (response) => {
        this.opdataWithFlagD = [];
        this.opdataWithFlagD = response;
      },
    });
  }

  getGetOPdatawithIflagById(TrainId) {
    this.opdataService.GetOPdatawithIflagById(TrainId).subscribe({
      next: (response) => {
        this.opdataWithFlagI = [];
        this.opdataWithFlagI = response;
      },
    });
  }

  // showCalc() {
  //   if (this.PlantId == undefined) {
  //     var id = btoa(this.trainDetails.Id.toString())
  //     this.router.navigate([
  //       '/trains/edit/' + id + '/opdata'
  //     ], {
  //       queryParams: {
  //         showselector: true,
  //         PlantId: btoa(this.trainDetails.PlantId.toString()),
  //         trainId: btoa(this.trainDetails.Id.toString()),

  //           MaxPageSize: this.queryParam?.MaxPageSize,
  //         SearchQuery: this.queryParam?.SearchQuery,
  //         PageNumber: this.queryParam?.PageNumber,
  //         PageSize: this.queryParam?.PageSize,
  //         OrderBy: this.queryParam?.OrderBy,
  //         OrderDir: this.queryParam?.OrderDir,
  //         SelectedValue: this.queryParam?.SelectedValue
  //       },
  //     });
  //   } else {
  //     this.router.navigate(['/opdata'],{
  //       queryParams: {
  //         showselector: true,
  //         PlantId: btoa(this.trainDetails.PlantId.toString()),
  //         trainId: btoa(this.trainDetails.Id.toString()),

  //          MaxPageSize: this.queryParam?.MaxPageSize,
  //         SearchQuery: this.queryParam?.SearchQuery,
  //         PageNumber: this.queryParam?.PageNumber,
  //         PageSize: this.queryParam?.PageSize,
  //         OrderBy: this.queryParam?.OrderBy,
  //         OrderDir: this.queryParam?.OrderDir,
  //         SelectedValue: this.queryParam?.SelectedValue
  //       },
  //       skipLocationChange: true,
  //     });
  //   }
  // }

showCalc() {
  const encodedTrainId = btoa(this.trainDetails.Id.toString());
  const encodedPlantId = btoa(this.trainDetails.PlantId.toString());

  // Determine the correct route
  const routeUrl = this.PlantId === undefined
    ? ['/trains/edit', encodedTrainId, 'opdata']
    : ['/opdata'];

  // Send everything through state
  const stateData = {
    showselector: true,
    PlantId: this.trainDetails.PlantId,
    trainId: this.trainDetails.Id,
    queryParamcalc: {
      MaxPageSize: this.queryParam?.MaxPageSize,
      SearchQuery: this.queryParam?.SearchQuery,
      PageNumber: this.queryParam?.PageNumber,
      PageSize: this.queryParam?.PageSize,
      OrderBy: this.queryParam?.OrderBy,
      OrderDir: this.queryParam?.OrderDir,
      SelectedValue: this.queryParam?.SelectedValue
    }
  };

  this.router.navigate(routeUrl, {
    state: stateData,
    skipLocationChange: true  // Keeps the URL clean
  });
}


  showRaw() {
    var id = btoa(this.trainDetails.Id.toString())
    this.router.navigate([
      '/trains/rawopdata/' + id,
    ]);
  }

  downloadexport(e) {
    this.opdataService.exportOpdata(e).subscribe(
      (respData) => {
        this.downLoadFile(respData, this.type, e);
      },
      (error) => {}
    );
  }

  /**
   * Method is use to download file from server.
   * @param data - Array Buffer data
   * @param type - type of the document.
   */
  downLoadFile(data: any, type: string, trainId: string) {
    var blob = new Blob([data], { type: type.toString() });
    var url = window.URL.createObjectURL(blob);
    //var pwa = window.open(url);
    var anchor = document.createElement('a');
    anchor.download = 'opdata-export-' + trainId + '.xlsx';
    anchor.href = url;
    anchor.click();
  }

  getRawOpdatalst(selectedId: string) {
    //HD
    //6 Feb 2025
    //Change selected id to train id for fixing paging issue in raw opdata
    this.opdataService
      .getRawOpdataByTrainId(this.queryParam, this.trainId)
     
      .subscribe((response: DataOutputModel) => {
        this.opdataList = response.Items;
        this.pageHeaders = response.Paging;
        console.log(this.trainId);
      });
  }

  searchtable() {
    if (this.queryParam.SearchQuery) {
      this.queryParam.SearchQuery = this.queryParam.SearchQuery.replace(/\//g, '-');
    }
    this.getRawOpdatalst(this.newId);
  }

  clearSearch() {
    
    this.getRawOpdatalst(this.newId);
  }

  onPageChange(newPage: number): void {
    this.queryParam.PageNumber = newPage;
    this.getRawOpdatalst(this.newId);
  }
  // onPageSizeChange(): void {
  //   this.queryParam.PageSize = +this.queryParam.PageSize;
  //   this.queryParam.MaxPageSize = +this.queryParam.PageSize;
  //   this.getRawOpdatalst(this.newId);
  // }

    onPageSizeChange(): void {
    this.queryParam.PageSize = +this.queryParam.PageSize;
    this.queryParam.MaxPageSize = +this.queryParam.PageSize;

    const totalItems = this.pageHeaders.TotalItems || 0;
    const maxValidPage = Math.ceil(totalItems / this.queryParam.PageSize) || 1;

    if (this.queryParam.PageNumber > maxValidPage) {
      this.queryParam.PageNumber = 1;
    }
    this.getRawOpdatalst(this.newId);
  }
  
  onSortClick(event, columnname) {
    let target = event.currentTarget,
      classList = target.classList;

    if (classList.contains('fa-chevron-up')) {
      classList.remove('fa-chevron-up');
      classList.add('fa-chevron-down');
      this.sortDir = -1;
    } else {
      classList.add('fa-chevron-up');
      classList.remove('fa-chevron-down');
      this.sortDir = 1;
    }
    this.queryParam.OrderBy = columnname;
    this.queryParam.OrderDir = this.sortDir == -1 ? 'desc' : 'asc';
    this.getRawOpdatalst(this.newId);
  }
}
